<template>
  <w-radio-list
    :values="yesOrNo"
    :title="title"
    :model="model"
    :disabled="disabled.all"
    v-bind="{ ...$props, ...$attrs }"
    v-on="$listeners"
  >
    <slot />
  </w-radio-list>
</template>

<script>
import { componentMixin } from '@/mixins/document/component';
import { YES_OR_NO } from '@/utils/constants';

// @vuese
// komponent do opcji tak lub nie
// @Group formComponents
export default {
  mixins: [componentMixin],
  data() {
    return {
      yesOrNo: YES_OR_NO
    };
  }
};
</script>
